export default __webpack_public_path__ + "static/media/2.37e3c9f9.jpg";